import { useAdminCanEdit, useAdminLogout } from '@/features/admin/hooks';

/**
 * AdminLogoutButton — shared logout control for the admin console top bar.
 *
 * Drops the admin cookie via useAdminLogout, then sends the operator back to
 * /admin/login (even if the server call hiccupped). Identical behavior to the
 * inline handler the admin pages previously duplicated.
 *
 * Every route wires this into AdminShell's `actions` slot, so it's also the one
 * place to show the "View only" badge for a viewer — no per-page changes needed.
 * Logout itself stays a plain button for everyone, viewer included.
 */
export function AdminLogoutButton() {
  const logout = useAdminLogout();
  const canEdit = useAdminCanEdit();

  const handleLogout = async () => {
    try {
      await logout.mutateAsync();
    } catch {
      /* drop the cookie locally even if the server hiccupped */
    }
    window.location.assign('/admin/login');
  };

  return (
    <div className="flex items-center gap-2">
      {!canEdit && (
        <span className="py-1 px-2.5 bg-white/10 border border-white/20 rounded-full text-white/80 text-[11px] font-semibold uppercase tracking-[0.06em]">
          View only
        </span>
      )}
      <button
        type="button"
        onClick={() => void handleLogout()}
        className="py-2 px-4 bg-white/10 border border-white/20 rounded-[10px] text-white text-sm font-semibold cursor-pointer hover:bg-white/20 transition-colors"
      >
        Log Out
      </button>
    </div>
  );
}
